import { render } from "./AppLayout_12_4_8_12.vue?vue&type=template&id=be81e952&scoped=true"
import script from "./AppLayout_12_4_8_12.vue?vue&type=script&lang=js"
export * from "./AppLayout_12_4_8_12.vue?vue&type=script&lang=js"

import "./AppLayout_12_4_8_12.vue?vue&type=style&index=0&id=be81e952&scoped=true&lang=css"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be81e952"]])

export default __exports__